/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HighestConsumedPartsOutput } from '../../models/highest-consumed-parts-output';

export interface GetHighestConsumedParts$Params {

/**
 * Equipment serial number
 */
  serialNumber: string;

/**
 * Equipment material number
 */
  materialNumber: number;
}

export function getHighestConsumedParts(http: HttpClient, rootUrl: string, params: GetHighestConsumedParts$Params, context?: HttpContext): Observable<StrictHttpResponse<HighestConsumedPartsOutput>> {
  const rb = new RequestBuilder(rootUrl, getHighestConsumedParts.PATH, 'get');
  if (params) {
    rb.path('serialNumber', params.serialNumber, {});
    rb.path('materialNumber', params.materialNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HighestConsumedPartsOutput>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getHighestConsumedParts.PATH = '/api/SpareParts/HighestConsumedParts/{serialNumber}/{materialNumber}';
getHighestConsumedParts.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getHighestConsumedParts.ROOTURL = '/spareparts';
